<template>
	<section data-testid="resource-booking-component">

		<div class="bg-gray-12 text-xs-center p-a-grid b-t-dark b-b-dark" v-if="isWaiting || isLoadingOk">

			<!-- Pickleball Logo -->
			<svg v-if="activityName.indexOf('Pickleball') !== -1" version="1.1" xmlns="http://www.w3.org/2000/svg" width="549px" height="46px" viewBox="0 0 549 46" aria-labelledby="logoTitlePickleball" role="img" class="racquet-sport-logo" data-testid="racquetSportLogo">
				<title id="logoTitlePickleball">Life Time Pickleball</title>
				<path fill="#A2AAAD" d="M93.94,4.5v36h9.5V26.25h6.75v-8h-6.75v-5h7.5V4.5H93.94z M112.44,4.5v36h17v-9h-7.5v-5.25h6.75v-8h-6.75v-5 h7.5V4.5H112.44z M63.2,40.5v-36h9.49v27h8.5v9H63.2z M82.69,4.5h9.5v36h-9.5V4.5z M202.44,4.5v36h17v-9h-7.5v-5.25h6.75v-8h-6.75 v-5h7.5V4.5H202.44z M135.44,4.5v8.75h5.5V40.5h9.5V13.25h5.5V4.5H135.44z M157.44,4.5h9.5v36h-9.5V4.5z M187.19,4.5l-2.5,18 l-2.5-18h-13.5v36h9v-20l3.5,20h7l3.5-20v20h9v-36H187.19z M223.07,4.5c1.24,0,2.35,0.9,2.35,2.29c0,1.4-1.11,2.3-2.35,2.3 s-2.35-0.9-2.35-2.3C220.71,5.39,221.82,4.5,223.07,4.5z M223.07,8.59c0.95,0,1.73-0.76,1.73-1.81c0-1.04-0.78-1.8-1.73-1.8 c-0.96,0-1.73,0.75-1.73,1.8C221.34,7.83,222.1,8.59,223.07,8.59z M222.15,5.5h0.97c0.64,0,1.01,0.2,1.01,0.76 c0,0.47-0.29,0.66-0.67,0.69l0.69,1.12h-0.53l-0.63-1.1h-0.32v1.1h-0.51L222.15,5.5L222.15,5.5z M222.66,6.57h0.45 c0.29,0,0.5-0.04,0.5-0.36c0-0.28-0.29-0.32-0.53-0.32h-0.43L222.66,6.57L222.66,6.57z"/>
				<path fill="#00A7E1" d="M244.81,4.35h17.78c6.48,0,10.43,4.35,10.43,10.79c0,9.11-6.74,13.67-15.55,13.67h-8.36l-2.48,11.7h-9.42 L244.81,4.35z M250.73,21.06h6.64c4.35,0,6.23-2.08,6.23-5.06c0-3.5-2.73-3.9-5.67-3.9h-5.32L250.73,21.06z M278.66,4.35h9.42 l-7.55,36.16h-9.42L278.66,4.35z M312.54,17.36c0.4-3.34-1.42-6.03-5.83-6.03c-7.14,0-9.82,8.26-9.82,13.98 c0,4.66,1.37,8.21,6.68,8.21c3.95,0,6.99-2.73,7.65-6.38h9.42c-2.03,9.27-7.85,14.13-18.38,14.13c-5.72,0-14.79-2.89-14.79-16.31 c0-11.65,7.14-21.37,19.4-21.37c9.06,0,15.2,4.25,15.09,13.77H312.54z M328.09,4.35h9.42l-2.99,14.18h0.1l14.74-14.18h12.46 l-17.27,14.89l10.73,21.27h-10.73l-7.45-15.2l-4.91,4.21l-2.33,10.99h-9.42L328.09,4.35z M365.54,4.35h9.42l-5.88,28.06H386 l-1.72,8.1h-26.29L365.54,4.35z M426.91,4.35h16.86c9.78,0,11.3,3.95,11.3,7.9c0,4.76-2.53,8-6.68,8.91v0.1 c3.19,0.76,5.11,3.85,5.11,7.09c0,7.34-5.87,12.1-16.46,12.16h-17.68L426.91,4.35z M430.25,33.12h7.39c3.29,0,6.43-0.71,6.43-4.61 c0-3.34-3.04-3.6-5.47-3.6h-6.64L430.25,33.12z M433.29,18.58h6.68c3.8,0,5.67-1.22,5.67-4c0-2.64-2.73-2.84-4.76-2.84h-6.18 L433.29,18.58z M472.75,4.35h9.52l5.92,36.16h-9.47l-0.86-6.48h-12.71l-3.65,6.48h-9.88L472.75,4.35z M468.8,27.04h8.26l-1.37-13.02 h-0.1L468.8,27.04z M498.78,4.35h9.42l-5.88,28.06h16.92l-1.72,8.1h-26.29L498.78,4.35z M528.16,4.35h9.42l-5.88,28.06h16.92 l-1.72,8.1h-26.29L528.16,4.35z M394.82,4.35l-1.68,8.1h28.83l1.72-8.1H394.82z M417.76,25.52l1.52-7.29h-27.34l-4.61,22.28h28.97 l1.72-8.1h-19.61l1.42-6.89H417.76z M38.41,6.59c-8.79-8.79-23.03-8.79-31.82,0s-8.79,23.03,0,31.82s23.03,8.79,31.82,0 S47.2,15.38,38.41,6.59z M3.75,25.62c-1.15,0-2.08-1.4-2.08-3.13s0.93-3.12,2.08-3.12s2.08,1.4,2.08,3.12 C5.83,24.23,4.9,25.62,3.75,25.62z M22.5,1.68c1.73,0,3.13,0.93,3.13,2.08s-1.4,2.08-3.13,2.08c-1.73,0-3.12-0.93-3.12-2.08 S20.77,1.68,22.5,1.68z M9.26,9.26C10.73,7.8,12.8,7.5,13.9,8.6s0.8,3.18-0.66,4.64C11.77,14.7,9.7,15,8.6,13.9S7.8,10.73,9.26,9.26 z M13.9,36.4c-1.1,1.1-3.18,0.8-4.64-0.66S7.5,32.2,8.6,31.1s3.18-0.8,4.64,0.66C14.7,33.23,15,35.3,13.9,36.4z M16.53,25.15 c-1.46,1.46-3.84,1.46-5.3,0s-1.46-3.84,0-5.3c1.46-1.46,3.84-1.46,5.3,0S17.99,23.69,16.53,25.15z M19.85,11.22 c1.46-1.46,3.84-1.46,5.3,0c1.46,1.46,1.46,3.84,0,5.3s-3.84,1.46-5.3,0C18.38,15.06,18.38,12.69,19.85,11.22z M22.5,43.35 c-1.73,0-3.12-0.93-3.12-2.08s1.4-2.08,3.12-2.08c1.73,0,3.13,0.93,3.13,2.08S24.23,43.35,22.5,43.35z M25.15,33.78 c-1.46,1.46-3.84,1.46-5.3,0s-1.46-3.84,0-5.3s3.84-1.46,5.3,0C26.62,29.94,26.62,32.31,25.15,33.78z M28.47,19.85 c1.46-1.46,3.84-1.46,5.3,0s1.46,3.84,0,5.3s-3.84,1.46-5.3,0C27.01,23.69,27.01,21.31,28.47,19.85z M35.74,35.74 c-1.46,1.46-3.54,1.76-4.64,0.66c-1.1-1.1-0.8-3.18,0.66-4.64C33.23,30.3,35.3,30,36.4,31.1C37.5,32.2,37.2,34.27,35.74,35.74z M36.4,13.9c-1.1,1.1-3.18,0.8-4.64-0.66C30.3,11.77,30,9.7,31.1,8.6s3.18-0.8,4.64,0.66C37.2,10.73,37.5,12.8,36.4,13.9z M41.25,25.62c-1.15,0-2.08-1.4-2.08-3.13s0.93-3.12,2.08-3.12s2.08,1.4,2.08,3.12C43.32,24.23,42.39,25.62,41.25,25.62z"/>
			</svg>

			<!-- Racquetball Logo -->
			<svg v-if="activityName.indexOf('Racquetball') !== -1" version="1.1" xmlns="http://www.w3.org/2000/svg" width="611px" height="45px" viewBox="0 0 611 45" aria-labelledby="logoTitleRacquetball" role="img" class="racquet-sport-logo" data-testid="racquetSportLogo">
				<title id="logoTitleRacquetball">Life Time Racquetball</title>
				<path fill="#A2AAAD" d="M94.01,4.5v36h9.5V26.25h6.75v-8h-6.75v-5h7.5V4.5H94.01z M112.51,4.5v36h17v-9h-7.5v-5.25h6.75v-8h-6.75v-5 h7.5V4.5H112.51z M63.26,40.5v-36h9.5v27h8.5v9H63.26z M82.76,4.5h9.5v36h-9.5V4.5z M202.51,4.5v36h17v-9h-7.5v-5.25h6.75v-8h-6.75 v-5h7.5V4.5H202.51z M135.51,4.5v8.75h5.5V40.5h9.5V13.25h5.5V4.5H135.51z M157.51,4.5h9.5v36h-9.5V4.5z M187.26,4.5l-2.5,18 l-2.5-18h-13.5v36h9v-20l3.5,20h7l3.5-20v20h9v-36H187.26z M223.13,4.5c1.24,0,2.35,0.9,2.35,2.29c0,1.4-1.11,2.3-2.35,2.3 s-2.35-0.9-2.35-2.3S221.89,4.5,223.13,4.5z M223.13,8.59c0.95,0,1.73-0.76,1.73-1.81c0-1.04-0.78-1.8-1.73-1.8 c-0.96,0-1.73,0.75-1.73,1.8C221.41,7.83,222.17,8.59,223.13,8.59z M222.22,5.5h0.97c0.64,0,1.01,0.2,1.01,0.76 c0,0.47-0.29,0.66-0.67,0.69l0.69,1.12h-0.53l-0.63-1.1h-0.32v1.1h-0.51L222.22,5.5L222.22,5.5z M222.73,6.57h0.45 c0.29,0,0.5-0.04,0.5-0.36c0-0.28-0.29-0.32-0.53-0.32h-0.43L222.73,6.57L222.73,6.57z"/>
				<path fill="#004D71" d="M244.99,4.43h17.7c6.57,0,11.58,1.67,11.58,9.35c0,5.41-2.58,9.25-8.24,10.06v0.1 c2.68,0.66,3.69,2.53,3.69,6.02c0,2.63-0.15,4.65-0.15,6.73c0,1.26,0,2.83,0.56,3.84h-9.45c-0.15-0.71-0.3-1.36-0.3-2.07 c0-1.87,0.25-3.79,0.25-6.22c0-3.19-1.36-4.85-4.7-4.85h-6.27l-2.73,13.15h-9.4L244.99,4.43z M251.06,20.41h7.49 c3.39,0,6.32-1.06,6.32-4.96c0-3.08-2.58-3.74-5.06-3.74h-6.93L251.06,20.41z M293.12,4.43h9.5l5.92,36.1h-9.45l-0.86-6.47h-12.69 l-3.64,6.47h-9.86L293.12,4.43z M289.18,27.08h8.24l-1.37-12.99h-0.1L289.18,27.08z M334.42,17.42c0.4-3.34-1.42-6.02-5.82-6.02 c-7.13,0-9.81,8.24-9.81,13.96c0,4.65,1.36,8.19,6.67,8.19c3.94,0,6.98-2.73,7.63-6.37h9.41c-2.03,9.25-7.84,14.11-18.36,14.11 c-5.71,0-14.77-2.88-14.77-16.28c0-11.63,7.13-21.34,19.37-21.34c9.05,0,15.17,4.25,15.07,13.75H334.42z M373.43,44.63l-3.99-4.85 c-2.38,1.01-5.11,1.52-8.14,1.52c-10.06,0-15.88-5.91-15.88-15.98c0-11.99,7.79-21.64,20.23-21.64c6.27,0,16.08,2.33,16.08,15.27 c0,7.23-2.43,13.45-6.93,17.49l3.59,4.4L373.43,44.63z M366.3,26.07l2.88,3.49c2.08-2.83,3.14-6.67,3.14-9.81 c0-5.36-1.92-8.34-6.98-8.34c-7.28,0-10.52,7.99-10.52,13.96c0,4.65,2.22,8.19,7.23,8.19c0.71,0,1.36-0.1,2.02-0.3l-2.73-3.29 L366.3,26.07z M416.07,25.06c-2.02,9.71-4.95,16.23-18,16.23c-9.4,0-14.61-4.7-14.61-10.41c0-3.03,0.51-5.21,1.01-7.59l4.09-18.86 h9.41l-4.2,19.32c-0.35,1.72-0.91,3.59-0.91,5.51c0,2.68,2.03,4.3,5.41,4.3c6.47,0,7.49-4.8,8.8-10.52l3.89-18.61h9.4L416.07,25.06z M484.33,12.52h-10.62l-5.92,28.01h-9.4l5.92-28.01H421.8l1.62-8.09h62.53L484.33,12.52z M488.97,4.43h16.84 c9.76,0,11.28,3.94,11.28,7.89c0,4.75-2.53,7.99-6.67,8.9v0.1c3.19,0.76,5.11,3.84,5.11,7.08c0,7.33-5.86,12.08-16.43,12.14h-17.65 L488.97,4.43z M492.31,33.15h7.38c3.29,0,6.42-0.71,6.42-4.6c0-3.34-3.03-3.59-5.46-3.59h-6.62L492.31,33.15z M495.34,18.64h6.67 c3.79,0,5.67-1.21,5.67-3.99c0-2.63-2.73-2.83-4.76-2.83h-6.17L495.34,18.64z M534.67,4.43h9.51l5.91,36.1h-9.45l-0.86-6.47h-12.69 l-3.64,6.47h-9.86L534.67,4.43z M530.73,27.08h8.24l-1.37-12.99h-0.1L530.73,27.08z M560.66,4.43h9.4l-5.87,28.01h16.89l-1.72,8.09 h-26.24L560.66,4.43z M589.93,4.43h9.4l-5.87,28.01h16.89l-1.72,8.09h-26.24L589.93,4.43z M446.35,25.57l1.51-7.29l-27.29-0.01 l-4.61,22.26h28.92l1.72-8.09h-19.57l1.41-6.87H446.35z M31.34,31.34c8.33-8.33,11.65-19.16,7.59-24.2 c-0.17-0.18-0.34-0.37-0.52-0.54c-8.79-8.79-23.03-8.79-31.82,0s-8.79,23.03,0,31.82c0.13,0.13,0.27,0.26,0.4,0.38 C11.97,43.05,22.94,39.74,31.34,31.34z M44.12,16.25C43.09,21.98,39.6,28.38,34,33.99c-5.61,5.61-12.03,9.1-17.76,10.13 c7.62,2.2,16.17,0.3,22.18-5.7C44.41,32.41,46.31,23.87,44.12,16.25z"/>
			</svg>

			<!-- Squash Logo -->
			<svg v-if="activityName.indexOf('Squash') !== -1" version="1.1" xmlns="http://www.w3.org/2000/svg" width="446px" height="46px" viewBox="0 0 446 46" aria-labelledby="logoTitleSquash" role="img" class="racquet-sport-logo" data-testid="racquetSportLogo">
				<title id="logoTitleSquash">Life Time Squash</title>
				<path fill="#A2AAAD" d="M94,4.62v36h9.5v-14.2h6.8v-8h-6.8v-5h7.5v-8.8H94z M112.5,4.62v36h17v-9H122v-5.2h6.8v-8H122v-5h7.5v-8.8 H112.5z M63.3,40.62v-36h9.5v27h8.5v9H63.3z M82.8,4.62h9.5v36h-9.5V4.62z M202.5,4.62v36h17v-9H212v-5.2h6.8v-8H212v-5h7.5v-8.8 H202.5z M135.5,4.62v8.8h5.5v27.2h9.5v-27.2h5.5v-8.8H135.5z M157.5,4.62h9.5v36h-9.5V4.62z M187.3,4.62l-2.5,18l-2.5-18h-13.5v36h9 v-20l3.5,20h7l3.5-20v20h9v-36H187.3z M223.1,4.62c1.2,0,2.4,0.9,2.4,2.3s-1.1,2.3-2.4,2.3s-2.4-0.9-2.4-2.3 C220.8,5.52,221.9,4.62,223.1,4.62z M223.1,8.72c0.9,0,1.7-0.8,1.7-1.8s-0.8-1.8-1.7-1.8c-1,0-1.7,0.8-1.7,1.8 C221.4,8.02,222.2,8.72,223.1,8.72z M222.2,5.62h1c0.6,0,1,0.2,1,0.8c0,0.5-0.3,0.7-0.7,0.7l0.7,1.1h-0.5l-0.6-1.1h-0.3v1.1h-0.5 L222.2,5.62L222.2,5.62z M222.7,6.72h0.4c0.3,0,0.5,0,0.5-0.4c0-0.3-0.3-0.3-0.5-0.3h-0.4V6.72L222.7,6.72z"/>
				<path fill="#B68400" d="M242.8,28.52c0,3.9,2.2,5.2,6.6,5.2c3.8,0,5.4-1.6,5.4-3.6c0-3.6-5.5-4-9.2-5.3c-4.5-1.6-8.1-4-8.1-9.3 c0-8.2,7.4-11.6,14.6-11.6c7.7,0,14.2,2.8,13.9,11.6h-9.4c0-1.4-0.5-2.3-1.3-2.9c-0.9-0.7-2.1-1-3.8-1c-2.3,0-4.7,1-4.7,3.2 s1.5,2.4,6.5,3.8c4.9,1.4,10.7,3.9,10.7,11c0,6.4-5.7,11.8-16.2,11.8c-8.6,0-14.6-4.3-14.5-12.9 C233.4,28.52,242.8,28.52,242.8,28.52z M295.7,44.72l-4-4.8c-2.4,1-5.1,1.5-8.1,1.5c-10,0-15.8-5.9-15.8-15.9 c0-12,7.8-21.6,20.2-21.6c6.2,0,16,2.3,16,15.2c0,7.2-2.4,13.4-6.9,17.5l3.6,4.4L295.7,44.72z M288.6,26.22l2.9,3.5 c2.1-2.8,3.1-6.7,3.1-9.8c0-5.3-1.9-8.3-7-8.3c-7.3,0-10.5,8-10.5,13.9c0,4.6,2.2,8.2,7.2,8.2c0.7,0,1.4-0.1,2-0.3l-2.7-3.3 L288.6,26.22z M338.5,25.22c-2,9.7-4.9,16.2-18,16.2c-9.4,0-14.6-4.7-14.6-10.4c0-3,0.5-5.2,1-7.6l4.1-18.8h9.4l-4.2,19.3 c-0.4,1.7-0.9,3.6-0.9,5.5c0,2.7,2,4.3,5.4,4.3c6.5,0,7.5-4.8,8.8-10.5l3.9-18.6h9.4L338.5,25.22z M414.5,4.62h9.4l-2.7,13.1h12.5 l2.7-13.1h9.4l-7.5,36h-9.4l3.1-14.8h-12.5l-3.1,14.8H407L414.5,4.62z M371.3,27.22h-8.9l0,0h-8.2l6.8-13h0.1l0.8,7.2h8.6l-2.9-16.8 h-9.5l-21,36h9.8l3.6-6.5h12.7l0.9,6.5h9.4L371.3,27.22z M394.9,18.62c-5-1.4-6.5-1.6-6.5-3.8c0-2.3,2.4-3.2,4.7-3.2 c1.7,0,2.9,0.3,3.8,1c0.8,0.6,1.3,1.6,1.3,2.9h9.4c0.2-8.8-6.2-11.6-13.9-11.6c-7.2,0-14.6,3.5-14.6,11.6c0,5.3,3.6,7.7,8.1,9.3 c3.7,1.3,9.2,1.7,9.2,5.3c0,2-1.6,3.6-5.4,3.6c-4.4,0-6.6-1.3-6.6-5.2l0,0v-1.4H375v1.4c-0.1,8.5,5.9,12.9,14.5,12.9 c10.5,0,16.2-5.4,16.2-11.8C405.7,22.52,399.9,19.92,394.9,18.62z M22.6,0.02C10.1,0.02,0,10.12,0,22.62s10.1,22.6,22.6,22.6 s22.6-10.1,22.6-22.6S35.1,0.02,22.6,0.02z M13.1,22.52c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7 C15.7,21.32,14.5,22.52,13.1,22.52z M19.9,15.62c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7 C22.5,14.42,21.4,15.62,19.9,15.62z"/>
			</svg>

			<!-- Tennis Logo -->
			<svg v-if="activityName.indexOf('Tennis') !== -1" version="1.1" xmlns="http://www.w3.org/2000/svg" width="405px" height="45px" viewBox="0 0 405 45" aria-labelledby="logoTitleTennis" role="img" class="racquet-sport-logo" data-testid="racquetSportLogo">
				<title id="logoTitleTennis">Life Time Tennis</title>
				<path fill="#009877" d="M291.88,18.02l-1.48,7.22h-17.44l-1.38,6.82h19.06l-1.67,8.03H260.8l4.49-22.04L291.88,18.02z M294.49,12.3 l1.67-8.03h-57.93l-1.58,8.03h10.34l-5.76,27.79h9.16l5.76-27.79C256.15,12.3,294.49,12.3,294.49,12.3z M320.74,4.28l-4.38,23.42 h-0.1l-8.22-23.42h-9.41l-7.34,35.81h8.87l4.48-23.42h0.1l8.13,23.42h9.41l7.34-35.81C329.62,4.28,320.74,4.28,320.74,4.28z M354.38,4.28L350,27.7h-0.09l-8.23-23.42h-9.4l-7.34,35.81h8.87l4.48-23.42h0.1l8.13,23.42h9.4l7.34-35.81 C363.26,4.28,354.38,4.28,354.38,4.28z M366.29,4.28l-7.34,35.81h9.16l7.34-35.81C375.45,4.28,366.29,4.28,366.29,4.28z M390.97,3.52c-7.04,0-14.28,3.46-14.28,11.59c0,5.27,3.55,7.62,7.93,9.23c3.64,1.31,8.96,1.71,8.96,5.27 c0,1.96-1.53,3.56-5.22,3.56c-4.33,0-6.45-1.25-6.45-5.12h-9.16c-0.1,8.48,5.76,12.79,14.14,12.79c10.29,0,15.86-5.37,15.86-11.74 c0-7.02-5.66-9.58-10.49-10.93c-4.93-1.35-6.4-1.61-6.4-3.76c0-2.26,2.36-3.21,4.63-3.21c1.3-0.1,2.6,0.24,3.7,0.95 c0.85,0.7,1.32,1.79,1.23,2.91h9.16C404.81,6.33,398.45,3.52,390.97,3.52 M9.78,40.78c1.19-0.29,2.32-0.81,3.31-1.53 c3.4-2.51,4.56-7.17,4.93-10.63c0.47-4.4,2.36-8,5.46-10.41c3.16-2.41,7.14-3.45,11.08-2.91c1.62,0.23,6.99,1.4,10.08,6.6 C44.39,9.57,34.21-0.23,21.89,0C9.57,0.24-0.23,10.42,0,22.74C0.14,29.99,3.79,36.71,9.78,40.78z"/>
				<path fill="#A2AAAD" d="M93.41,4.23v36h9.5V25.98h6.75v-8h-6.75v-5h7.5V4.23H93.41z M111.91,4.23v36h17v-9h-7.5v-5.25h6.75v-8h-6.75 v-5h7.5V4.23H111.91z M62.66,40.23v-36h9.5v27h8.5v9H62.66z M82.16,4.23h9.5v36h-9.5V4.23z M201.91,4.23v36h17v-9h-7.5v-5.25h6.75 v-8h-6.75v-5h7.5V4.23H201.91z M134.91,4.23v8.75h5.5v27.25h9.5V12.98h5.5V4.23H134.91z M156.91,4.23h9.5v36h-9.5V4.23z M186.66,4.23l-2.5,18l-2.5-18h-13.5v36h9v-20l3.5,20h7l3.5-20v20h9v-36H186.66z M222.53,4.23c1.24,0,2.35,0.9,2.35,2.29 c0,1.4-1.11,2.3-2.35,2.3s-2.35-0.9-2.35-2.3S221.29,4.23,222.53,4.23z M222.53,8.32c0.95,0,1.73-0.76,1.73-1.81 c0-1.04-0.78-1.8-1.73-1.8c-0.96,0-1.73,0.75-1.73,1.8C220.81,7.56,221.57,8.32,222.53,8.32z M221.62,5.23h0.97 c0.64,0,1.01,0.2,1.01,0.76c0,0.47-0.29,0.66-0.67,0.69l0.69,1.12h-0.53l-0.63-1.1h-0.32v1.1h-0.51L221.62,5.23L221.62,5.23z M222.13,6.3h0.45c0.29,0,0.5-0.04,0.5-0.36c0-0.28-0.29-0.32-0.53-0.32h-0.43L222.13,6.3L222.13,6.3z M41.37,24.29 c-2.13-3.97-6.2-4.84-7.39-5.01c-2.85-0.37-5.73,0.38-8.03,2.11c-2.25,1.74-3.57,4.32-3.93,7.65c-0.66,6.12-2.92,10.77-6.54,13.44 c-0.34,0.25-0.7,0.48-1.07,0.7c10.48,3.97,22.2-0.46,27.5-10.18c0.4-0.73,0.63-1.53,0.68-2.36C42.72,28.19,42.32,26.05,41.37,24.29z "/>
			</svg>

			<a role="button" @click="handlePoliciesModalShow()" class="link-underlined" data-testid="policiesModalBtn">View reservation and cancellation policies</a>

		</div>

		<!-- Date Bar (Date Nav) -->
		<ResourceBookingDateBarSub
			v-if="days.length > 0 && selectedDate"
			:days="days"
			:selectedDate="selectedDate"
			:maxDay="maxDay"
			@dayChanged="handleDateBarChanged"
			@weekChanged="handleDateBarChanged"
		/>

		<!-- Filters and Chiclets -->
		<ResourceBookingFilters
			v-if="isWaiting || isLoadingOk"
			ref="resourceBookingFilters"
			:facets="facetData"
			:queryFilters="queryFilters"
			:isWaiting="isWaiting"
			:isInitialLoad="isInitialLoad"
			@changed="handleFiltersChanged"
			@applyFilters="handleFiltersApplied"
			@closeFilters="closeFilters"
		/>

		<div class="bg-gray-11 b-t-dark" v-if="isWaiting || isLoadingOk">
			<div class="container">
				<div class="row">
					<div class="col-xs-12">
						<div class="m-b-grid">
							<div v-if="!isLoadingResourceResults">
								<div v-if="resourceResults && resourceResults.dayParts && resourceResults.dayParts.length" data-testid="resourceBookingTileResults">
									<div v-for="(dayPart, dayPartIndex) in resourceResults.dayParts" :key="dayPartIndex" class="resource-booking-bucket">
										<div v-if="dayPart.availableTimes.length > 0" class="resource-booking-daypart" :class="'resource-booking-daypart-'+dayPart.name.toLowerCase()">
											{{ dayPart.name }}
										</div>
										<a :href="createReservationUrl(timeslot)" class="timeslot" v-for="(timeslot, startTimeIndex) in dayPart.availableTimes" :key="startTimeIndex" :data-testid="`resourceBookingTile`">
											<div class="timeslot-time">{{ timeslot.time }}</div>
											<div class="timeslot-resource">{{ timeslot.resourceName }}</div>
										</a>
									</div>
								</div>
								<div v-else-if="!activityName" class="m-y-2 text-xs-center" data-testid="resourceBookingNoResults">Please apply filters to view court availability.</div>
								<div v-else-if="dateUnavailable" class="m-y-2 text-xs-center">We’re sorry, courts for this date are not yet reservable.</div>
								<div v-else-if="noResults" class="m-y-2 text-xs-center">No court reservations available for this day based on the current filter selections. Please select another day or adjust your filters to check other availability.</div>
								<div v-else class="m-y-2 text-xs-center">Sorry, an unknown error occurred. Please try again.</div>
							</div>
							<div v-else class="m-y-2 text-xs-center">Loading...</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Loading Spinner -->
		<div role="alert" aria-live="assertive">
			<transition name="fade" appear>
				<div class="spinner-overlay" data-testid="spinner" v-show="isWaiting">
					<p class="sr-only">Courts are loading…</p>
					<LoadingSpinner />
				</div>
			</transition>
		</div>

		<Modal ref="policiesModal" ariaLabelled="policiesModalTitle" data-testid="policiesModal">
			<template #title>Reservation and Cancellation Policies</template>
			<template #default>
				<div v-if="activityName.indexOf('Pickleball') !== -1" data-testid="policiesModalText">
					<ul class="p-l-2">
						<li>Online pickleball court reservations must be made at least 10 minutes in advance.</li>
						<li>A cancellation notice is required greater than 24 hours prior to the reservation.</li>
						<li>Payment options include: club tab, cash, check, or credit card.</li>
						<li>Indoor court time charges are based on the membership type of the players utilizing the court time, not based on which member made the court reservation.</li>
						<li>Indoor court time charges (if applicable) are divided amongst all of the players utilizing the same court. Indoor court time charges vary by club/Center. See your club/Center for additional details.</li>
						<li>Signature and Premier members will not be charged for indoor court time (even though a price is shown when booking) except at Sky, PENN1, and Dumbo, at which a fee applies. Only members with a Premier Membership may access the pickleball courts in NYC. A reservation fee for Premier members’ use of Life Time Sky, PENN1, or Dumbo pickleball courts will be charged at the Pickleball Desk or Concierge Desk</li>
						<li>Standard, Signature and Premier members are subject to late court reservation cancellation and no-show fees and/or restrictions, including but not limited to, payment of the reservation fee, payment of no-show fees and/or restricted court access (“Court Reservation No-Show Costs”). Court Reservation No-Show Costs vary by club/Center and will be charged without notice to member’s Monthly Payment Method or Club Tab.</li>
						<li>Premier members will be charged without notice for pickleball reservations to their Monthly Payment Account or Club Tab that are not cancelled prior to 24 hours before the reservation and/or if they are not used (no-show).</li>
						<li>Racquet Sport court reservations are limited to one court reservation per day, per member.</li>
						<li>Club/Center reserves the right to move a reservation to a different court on the same date and time, if needed.</li>
					</ul>
				</div>
				<div v-else-if="activityName.indexOf('Racquetball') !== -1" data-testid="policiesModalText">
					<ul class="p-l-2">
						<li>Online racquetball court reservations must be made at least 10 minutes in advance.</li>
						<li>A two-hour cancellation notice is required, or a $10 no-show fee will apply.</li>
						<li>Each member may only reserve one racquetball court per day, per club.</li>
						<li>Court access is for racquetball play only.</li>
						<li>Racquet Sport court reservations are limited to one court reservation per day, per member.</li>
						<li>Club/Center reserves the right to move a reservation to a different court on the same date and time, if needed.</li>
					</ul>
				</div>
				<div v-else-if="activityName.indexOf('Squash') !== -1" data-testid="policiesModalText">
					<ul class="p-l-2">
						<li>Online squash court reservations must be made at least 10 minutes in advance.</li>
						<li>A 24-hour cancellation notice is required prior to the reservation, or a no-show fee will apply (up to $30).</li>
						<li>Court reservations can be canceled via the “My Reservations” section of your online account, up until 24 hours before the start time of the reservation. The no show fee will apply if you fail to show up and cancel.</li>
						<li>Standard, Signature and Premier members are subject to late court reservation cancellation and no-show fees and/or restrictions, including but not limited to, payment of the reservation fee, payment of no-show fees and/or restricted court access (“Court Reservation No-Show Costs”). Court Reservation No-Show Costs vary by club/Center and will be charged without notice to member’s Monthly Payment Method or Club Tab.</li>
						<li>Racquet Sport court reservations are limited to one court reservation per day, per member.</li>
						<li>Club/Center reserves the right to move a reservation to a different court on the same date and time, if needed.</li>
						<li>Court access is for squash play only. No other sports or activities are permitted on the squash courts.</li>
					</ul>
				</div>
				<div v-else-if="activityName.indexOf('Tennis') !== -1" data-testid="policiesModalText">
					<ul class="p-l-2">
						<li>Online tennis court reservations must be made at least 10 minutes in advance.</li>
						<li>A cancellation notice is required greater than 24 hours prior to the reservation.</li>
						<li>Payment options include: club tab, cash, check, or credit card.</li>
						<li>Indoor court time charges are based on the membership type of the players utilizing the court time, not based on which member made the court reservation.</li>
						<li>Indoor court time charges (if applicable) are divided amongst all of the players utilizing the same court. Indoor court time charges vary by club/Center. See your club/Center for additional details.</li>
						<li>Signature and Premier members will not be charged for indoor court time (even though a price is shown when booking).</li>
						<li>Standard, Signature and Premier members are subject to late court reservation cancellation and no-show fees and/or restrictions, including but not limited to, payment of the reservation fee, payment of no-show fees and/or restricted court access (“Court Reservation No-Show Costs”). Court Reservation No-Show Costs vary by club/Center and will be charged without notice to member’s Monthly Payment Method or Club Tab.</li>
						<li>Racquet Sport court reservations are limited to one court reservation per day, per member.</li>
						<li>Club/Center reserves the right to move a reservation to a different court on the same date and time, if needed.</li>
					</ul>
				</div>
				<div v-else data-testid="policiesModalText">
					<ul class="p-l-2">
						<li>Please apply filters to view policies.</li>
					</ul>
				</div>
			</template>
		</Modal>

	</section>
</template>

<script>
import { defineComponent } from 'vue';
import moment from 'moment';
import findLast from 'lodash/findLast';
import { baseComponentMixin } from '@/mixins/baseComponent.mixin';
import { clockObservable$, dateProvider } from '@/services/clock.service';
import { FrameworkService } from '@/services/framework.service';
import { momentProvider } from '@/services/clock.service';
import { StateService } from '@/services/state.service';
import { NotificationService } from '@/services/notification.service';
import { Helpers } from '@/common/helpers';
import Modal from '@/components/schreg-common/Modal.vue';
import LoadingSpinner from '@/components/schreg-common/LoadingSpinner.vue';
import ResourceBookingDateBarSub from './subs/ResourceBookingDateBarSub.vue';
import ResourceBookingFilters from './subs/ResourceBookingFilters.vue';
import { UxSchedulesApi } from '@/apis/uxSchedules.api';

let clockSubscription;

export const ResourceBookingFilterFacets = {
	clubId: 'clubId',
	sport: 'sport',
	duration: 'duration',
	date: 'date',
	startTime: 'startTime'
};

export const HideModalQueryStringKey = 'hideModal';

export default defineComponent({
	name: 'ResourceBookingComponent',
	config: {
		key: 'schreg.resourceBooking',
		devPath: 'resource-booking',
		exported: true
	},
	components: {
		Modal,
		LoadingSpinner,
		ResourceBookingDateBarSub,
		ResourceBookingFilters
	},
	mixins: [
		baseComponentMixin
	],
	data() {
		return {
			now: dateProvider(),
			lastRefresh: dateProvider(),
			isMobileApp: false,
			isInitialLoad: false,
			isLoadingResourceResults: false,
			isRefreshing: false,
			classesUrl: FrameworkService.classesUrl(),
			facilitiesUrl: FrameworkService.facilitiesUrl(),
			courtsUrl: FrameworkService.courtsUrl(),
			selectedDate: null,
			maxDay: null,
			days: [],
			backgroundData: {},
			queryFilters: [],
			resourceResults: null,
			resourceFilterResults: null,
			facetData: null,
			searchFilters: [],
			activityName: '',
			noResults: false,
			dateUnavailable: false
		};
	},
	created() {
		clockSubscription = clockObservable$
			.subscribe(m => {
				this.now = m;

				// Refresh data every 30 seconds if filters aren't open and selected date is in range
				if (!$('#resourceBookingFiltersModal').hasClass('in') && !this.dateUnavailable) {
					if (this.now > (this.lastRefresh + 30000) && !this.isRefreshing) {
						this.isWaiting = true;
						this.loadResourceBookingData(true);
					}
				}
			});
	},
	mounted() {
		this.getFrameworkData(this.completeMounting, ['ClubStore', 'UrlStore', 'ProfileStore']);
		this.isMobileApp = Helpers.isMobileApp();

		// Override overflow: hidden on member site to make sticky positioning work
		if (document.getElementsByClassName('main-mylt').length > 0) {
			document.getElementsByClassName('main-mylt')[0].style.overflow = 'visible';
		}
	},
	destroyed() {
		clockSubscription.unsubscribe();
	},
	methods: {
		isModalHiddenInQueryString() {
			// this.isInitialLoad = StateService.getQuery(HideModalQueryStringKey) === null;
			this.isInitialLoad = false; // Always apply filters by default (TODO: If we keep this experience, we could get rid of the query string param)
			return !this.isInitialLoad;
		},

		completeMounting() {
			this.isModalHiddenInQueryString();
			this.setFiltersFromQueryString();
			this.buildDateNavDays();
			this.setDateNavData();
			this.loadResourceBookingData(!this.isInitialLoad);
		},

		handlePoliciesModalShow() {
			this.$refs.policiesModal.show();
		},

		createReservationUrl(timeslot) {
			let reserveUrl = FrameworkService.reserveResourceUrl(timeslot.resourceId, '', timeslot.start, timeslot.duration);
			reserveUrl = FrameworkService.addResourceCancelUrl(reserveUrl, `&${HideModalQueryStringKey}=true`);
			return this.userAuthenticated ? reserveUrl : `${FrameworkService.globalUrl('login')}?resource=${encodeURIComponent(reserveUrl)}`;
		},

		setFiltersFromQueryString() {
			this.setSelectedSport(StateService.getQuery(ResourceBookingFilterFacets.sport));
			this.setSelectedClub(StateService.getQuery(ResourceBookingFilterFacets.clubId));
			this.setSelectedDate(StateService.getQuery(ResourceBookingFilterFacets.date));
			this.setSelectedStartTime(StateService.getQuery(ResourceBookingFilterFacets.startTime));
			this.setSelectedDuration(StateService.getQuery(ResourceBookingFilterFacets.duration));
		},

		setSelectedClub(selectedClubId) {
			if (selectedClubId) {
				this.searchFilters.clubId = selectedClubId;
			}
		},

		setSelectedDuration(selectedDuration) {
			if (selectedDuration) {
				this.searchFilters.duration = selectedDuration;
			}
		},

		setSelectedSport(selectedSport) {
			if (selectedSport) {
				this.searchFilters.sport = selectedSport;
			}
		},

		setSelectedStartTime(selectedStartTime) {
			if (selectedStartTime) {
				this.searchFilters.startTime = selectedStartTime;
			}
		},

		setSelectedDate(selectedDate) {
			if (!selectedDate) {
				selectedDate =
					StateService.getQuery(ResourceBookingFilterFacets.date)
					|| moment.parseZone(momentProvider().startOf('day')).format('YYYY-MM-DD');
			}
			const date = Helpers.parseDateToMoment(selectedDate).startOf('day'); // Will always be midnight in the local time zone
			this.backgroundData.selectedDate = date;
			this.searchFilters.date = date.format('YYYY-MM-DD');
		},

		buildDateNavDays() {
			const days = [];
			let dayDataStart = this.backgroundData.selectedDate.clone().startOf('week');
			let dateFilterDays = [];

			if (this.facetData) {
				const dateFilter = this.facetData.find(f => f.filter.toLowerCase() === 'date');
				dateFilterDays = dateFilter.values;
				this.maxDay = Helpers.parseDateToMoment(findLast(dateFilterDays, d => d.enabled).key).startOf('day');
				dayDataStart = Helpers.parseDateToMoment(dateFilterDays[0].key).startOf('week');
			}

			let currMonth = '';

			for (let i = 0; i < 21; i++) { // Signature members can reserve 8 days out, so we need to allow up to 3 weeks (if booking on a Saturday, the 8th day is Sunday of the 3rd week)
				const day = dayDataStart.clone().add(i, 'days');
				const isInPast = day < momentProvider().startOf('day');
				const isViewing = this.backgroundData.selectedDate.clone().endOf('week').format('YYYY-MM-DD') === day.clone().endOf('week').format('YYYY-MM-DD'); //  Only show one week at a time in date nav
				let dayData = dateFilterDays.find(e => e.key === day.format('YYYY-MM-DD'));

				if (!dayData) {
					dayData = {
						key: day.format('YYYY-MM-DD'),
						isSelected: false,
						available: false,
						enabled: false,
						isViewing: isViewing
					};
				}

				let thisMonth = day.format('MMMM').toUpperCase();
				let thisMonthAbbr = day.format('MMM').toUpperCase();

				if (currMonth === thisMonth) {
					thisMonth = thisMonthAbbr = '';
				} else {
					currMonth = thisMonth;
				}

				days.push({
					index: i,
					eventData: dayData,
					selected: dayData.isSelected,
					noResults: !dayData.enabled,
					available: this.isModalHiddenInQueryString() ? dayData.available : false,
					isInPast: isInPast,
					isViewing: isViewing,
					today: dayData.key === momentProvider().format('YYYY-MM-DD'),
					value: dayData.key,
					display: {
						month: thisMonth,
						monthAbbr: thisMonthAbbr,
						dayName: day.format('ddd'),
						dayLetter: day.format('ddd').substring(0,1),
						dayNameFull: day.format('dddd'),
						dayNum: day.format('D'),
						total: dayData.total,
						ariaDate: day.format('dddd, MMMM D')
					}
				});
			}

			this.backgroundData.days = days;
		},

		loadResourceBookingData(applyResults) {
			this.isRefreshing = true;

			UxSchedulesApi
				.getResourceBookingData(this.searchFilters)
				.then(response => {
					this.lastRefresh = this.now;
					this.isRefreshing = false;

					if (!response.ok || !response.data || !response.data.filters) {
						NotificationService.danger('Sorry, an unknown error occurred. Please try again.').trigger();
						this.days = [];
						this.backgroundData.resourceResults = [];
						this.isWaiting = false;
						this.isLoadingResourceResults = false;
						return;
					}

					this.facetData = response.data.filters;
					this.backgroundData.resourceResults = response.data.results;
					this.setSelectedDate(response.data.results.day);
					this.isWaiting = false;
					this.isLoadingOk = true;
					this.isLoadingResourceResults = false;

					this.$nextTick(() => {
						if (applyResults) {
							this.handleFiltersApplied();
							this.$refs.resourceBookingFilters.applyChiclets(this.facetData);
						}
					});

				}, () => {
					NotificationService.danger('Sorry, an unknown error occurred. Please try again.').trigger();
					this.days = [];
					this.backgroundData.resourceResults = [];
					this.isWaiting = false;
					this.isLoadingResourceResults = false;
					return;
				});
		},

		handleSelectedDate(selectedDate) {
			this.isWaiting = true;
			this.dateUnavailable = false;
			this.noResults = false;
			if (!selectedDate.available) {
				this.resourceResults = null;
				this.dateUnavailable = true;
				this.isWaiting = false;
			} else if (selectedDate.noResults) {
				this.resourceResults = null;
				this.noResults = true;
				this.isWaiting = false;
			} else {
				this.$refs.resourceBookingFilters.triggerSelectedDateChange(selectedDate.value, this.isModalHiddenInQueryString());
			}
		},

		handleDateBarChanged(selectedDate) {
			this.setSelectedDate(selectedDate.value);
			this.handleSelectedDate(selectedDate);
			this.buildDateNavDays();
			this.setDateNavData();
		},

		handleFiltersChanged(facetName, filterClicked, shouldApplyUpdates) {
			if (shouldApplyUpdates) {
				// Only hide the results when the filters are edited through date nav
				this.isLoadingResourceResults = true;
			}

			this.isWaiting = true;

			if (facetName === ResourceBookingFilterFacets.sport) {
				this.setSelectedSport(filterClicked.key);
			} else if (facetName === ResourceBookingFilterFacets.clubId) {
				this.setSelectedClub(filterClicked.key);
			} else if (facetName === ResourceBookingFilterFacets.date) {
				this.setSelectedDate(filterClicked.key);
			} else if (facetName === ResourceBookingFilterFacets.startTime) {
				this.setSelectedStartTime(filterClicked.key);
			} else if (facetName === ResourceBookingFilterFacets.duration) {
				this.setSelectedDuration(filterClicked.key);
			}

			this.loadResourceBookingData(shouldApplyUpdates);
		},

		setDateNavData() {
			this.selectedDate = this.backgroundData.selectedDate;
			this.days = this.backgroundData.days;
		},

		handleFiltersApplied() {
			this.handleRebuildQueryFilters();
			this.setFiltersFromQueryString();
			this.buildDateNavDays();
			this.setDateNavData();
			this.resourceResults = this.backgroundData.resourceResults;
			this.activityName = this.searchFilters.sport;
		},

		handleRebuildQueryFilters() {
			const query = this.$refs.resourceBookingFilters.getQueryStringValues();

			for (const item of query) {
				StateService.setQueryStringKey(item.filter, item.value);
			}
			StateService.setQueryStringKey(HideModalQueryStringKey, 'true');
		},

		closeFilters(facets) {
			if (facets != null) {
				this.facetData = facets;
			}

			this.setFiltersFromQueryString();
		}
	}
});
</script>

<style lang="scss" scoped>
@import "@/common/styles/loading.scss";
@import "styles/resourceBooking.scss";
</style>
